<template>
  <base-detail :title="'Fish Starters'">
    <ul>
      <li class="menuList" v-for="item in fishStarters" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    fishStarters() {
      const dataList = data.filter(
        (row) => row.type === "fish" && row.mealType === "starters"
      );
      return dataList;
    },
  },
};
</script>
